<script setup lang="ts">
import { useOnTimezoneChange } from '@entities/viewer'
import { TasksKanbanTeam } from '@shared/config'

import { parseFilterParams } from '../model/filters/parse-filter-params'
import { useKanbanTasksApi } from '../api/kanban-tasks.hook'
import TasksKanbanTable from './TasksKanbanTable.vue'

defineOptions({
  name: 'TasksKanbanBillingPage',
})

const route = useRoute()

useOnTimezoneChange(() => {
  const params = parseFilterParams(route.query)
  void useKanbanTasksApi({ team: TasksKanbanTeam.Billing, params })
})
</script>

<template>
  <TasksKanbanTable />
</template>
